import { Injectable, OnInit } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { JobsService } from '../services/jobs.service';

@Injectable()
export class StateGuard  implements OnInit {
    constructor(public router: Router, private jobsService: JobsService) {
    }

    ngOnInit() {
    }

    canActivate(route: ActivatedRouteSnapshot) {
        return new Observable<boolean>((observer) => {
            this.jobsService.getJobById(_.get(route.parent.paramMap, 'params.workId')).subscribe(work => {
                let obj = work;
                let state = _.get(obj, route.data['statePath']);
                let match = _.some(route.data['stateTarget'], s => _.isEqual(state, s));
                if (!match) {
                    this.router.navigate(['/pages']);
                }
                observer.next(match);
            })
        })

    }
}
